import i18next from 'i18next'
import en from './en.js'
import vi from './vi.js'
import de from './de.js'

const resources = {
    vi,
    en,
    de
}

i18next.init({
    interpolation: {
        // React already does escaping
        escapeValue: false,
    },
    // keySeparator: false,
    fallbackLng: 'vi',
    lng: 'vi',
    // Using simple hardcoded resources for simple example
    resources,
    missingKeyHandler: (lngs, namespace, key, res) => {
        console.debug({ lngs, namespace })
    },
})

export default i18next
